(function(){
  'use strict';
  if(!/\/cart/.test(window.location.pathname))return;

  function patchCartItems(){
    var options = document.querySelectorAll('.ecom-cart__product-product-option, .product-option');
    if(!options.length)return;

    var items = document.querySelectorAll('.ecom-cart__product-item, .cart-item, [class*="cart"] [class*="product-info"], .ecom-cart__product');
    if(!items.length) items = [document.body];

    items.forEach(function(item){
      var allOpts = item.querySelectorAll('.ecom-cart__product-product-option, .product-option');
      var printSizeVal = null, sheetSizeVal = null, sizeOpt = null;

      allOpts.forEach(function(opt){
        var dt = opt.querySelector('dt');
        var dd = opt.querySelector('dd');
        if(!dt||!dd)return;
        var label = dt.textContent.trim().replace(':','').trim();
        if(label === 'Print Size'){
          printSizeVal = dd.textContent.trim();
          opt.setAttribute('data-dtf-patched','hide');
        }
        if(label === 'Sheet Size'){
          sheetSizeVal = dd.textContent.trim();
          opt.setAttribute('data-dtf-patched','hide');
        }
        if(label === 'Size') sizeOpt = opt;
      });

      if(printSizeVal && sizeOpt && !sizeOpt.getAttribute('data-dtf-patched')){
        var dt = sizeOpt.querySelector('dt');
        var dd = sizeOpt.querySelector('dd');
        if(dt && dd){
          dt.textContent = 'Custom Size: ';
          dd.innerHTML = '<strong style="color:#0f172a">' + printSizeVal + '</strong>'
            + '<span style="display:block;font-size:0.8em;color:#64748b;margin-top:2px">Printed on ' + dd.textContent.trim() + ' sheet</span>';
          sizeOpt.setAttribute('data-dtf-patched','done');
        }
      }

      allOpts.forEach(function(opt){
        if(opt.getAttribute('data-dtf-patched')==='hide') opt.style.display='none';
      });
    });
  }

  function tryPatch(){
    patchCartItems();
    var observer = new MutationObserver(function(mutations){
      var dominated = false;
      mutations.forEach(function(m){
        if(m.addedNodes.length) dominated = true;
      });
      if(dominated) setTimeout(patchCartItems, 50);
    });
    var target = document.querySelector('.ecom-cart__product-list, [class*="ecom-cart"], .cart-items, main, #MainContent');
    if(target) observer.observe(target, {childList:true, subtree:true});
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(tryPatch, 300); });
  } else {
    setTimeout(tryPatch, 300);
  }
  window.addEventListener('load', function(){ setTimeout(patchCartItems, 500); });
  window.addEventListener('load', function(){ setTimeout(patchCartItems, 1500); });
})();
